import { ISimpleUser } from "../components/config/Empleados";
import IActividad from "./Actividad";
import IHoliday from "./Holiday";
import IAsistenciaDoc from "./AsistenciaDoc";
import IMail from "./Mail";
import IOutOffice from "./OutOffice";
import IConsentimientoDoc from "./CI";
import IServicio from "./Servicio";
import IMetodoPago from "./MetodoPago";
import IBono from "./Bono";
import { IAgendaConfig } from "./AgendaConfig";
import IEntidadFacturacion, { IDatosFacturacion } from "./EntidadFacturacion";
import { IRegistroJornada } from "./Jornada";

export default interface IConfig {
    clinicName: string,
    clinicProvincia: string,
    clinicCity: string,
    clinicDomicilio: string,
    clinicEmail: string,
    clinicTelefono: string,
    clinicLogo: string | null,
    clinicColor: string | null,
    users: ISimpleUser[],
    outoffices: IOutOffice[],
    actividades: IActividad[],
    servicios: IServicio[],
    metodosPago: IMetodoPago[],
    salas: any,
    holidays: IHoliday[],
    mail: IMail,
    asistenciaDoc: IAsistenciaDoc,
    consentimientoDoc: IConsentimientoDoc,
    isFacturacionReady: Boolean,
    bonos: IBono[],
    reminders: Boolean,
    overlap: Boolean,
    agenda: IAgendaConfig,
    waConfig: Boolean,
    currency: string,
    datosFacturacion: IDatosFacturacion | null,
    datosFacturacionAdicional: IEntidadFacturacion[],
    registroJornada?: IRegistroJornada
}

export enum CONFIGTYPES {
    clinicName = 'clinicName',
    clinicProvincia = 'clinicProvincia',
    clinicCity = 'clinicCity',
    users = 'users',
    outoffices = 'outoffices',
    actividades = 'actividades',
    servicios = 'servicios',
    metodosPago = 'metodosPago',
    salas = 'salas',
    holidays = 'holidays',
    mail = 'mail',
    asistenciaDoc = 'asistenciaDoc',
    clinicDomicilio = 'clinicDomicilio',
    clinicEmail = 'clinicEmail',
    clinicTelefono = 'clinicTelefono',
    consentimientoDoc = 'consentimientoDoc',
    clinicLogo = 'clinicLogo',
    clinicColor = 'clinicColor',
    isFacturacionReady = 'isFacturacionReady',
    bonos = 'bonos',
    reminders = 'reminders',
    overlap = 'overlap',
    agenda = 'agenda',
    waConfig = 'waConfig',
    currency = 'currency',
    datosFacturacion = 'datosFacturacion',
    datosFacturacionAdicional = 'datosFacturacionAdicional'
};